export default import.meta.ROLLDOWN_FILE_URL_nXCnvL74adaOpiTcbaW7MQ